import { render, staticRenderFns } from "./recursos_lista.vue?vue&type=template&id=3a538970&"
import script from "./recursos_lista.vue?vue&type=script&lang=ts&"
export * from "./recursos_lista.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports